<script setup>
defineProps({ title: String, description: String });
</script>
<template>
  <div
    class="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between"
  >
    <div>
      <h2 class="page-title">{{ title }}</h2>
      <p v-if="description" class="mt-1 max-w-2xl text-sm text-slate-500">
        {{ description }}
      </p>
    </div>
    <div class="flex gap-2"><slot /></div>
  </div>
</template>
